module.exports = __webpack_public_path__ + "img/urAssessmentBlack.332adbdb.svg";